import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

export interface Props<T> {
  subscriptionRequest?: T
  onConfirm: (subscriptionRequest?: T) => void | Promise<void>
}

export const UnsubscribeOpenPositionModal: BaseModalType<Props<any>> = (props) => {
  const { close, onConfirm, subscriptionRequest } = props
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('Market Data.Attention')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>{t('Market Data.unsubscribe open position 1')}</Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>
          {t('Market Data.Keep subscription')}
        </Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={() => onConfirm(subscriptionRequest)}>
          {t('Market Data.Yes, unsubscribe')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
